<template>
	<portal :to="target">
		<transition name="modal">
			<div
				class="modal modal__mask"
				:class="className"
				v-if="show"
				@click="!disableOutSideClick ? close() : () => void 0"
			>
				<div
					class="modal__container"
					:class="{
						small: size == 'small',
						large: size == 'large',
						auto: size == 'auto',
						max: size == 'max',
					}"
					@click.stop
				>
					<button
						v-if="showCloseButton"
						class="modal__x"
						@click="close"
						:class="positionCloseX ? positionCloseX : ''"
					>
						&times;
					</button>
					<slot name="modal-content" />
				</div>
			</div>
		</transition>
	</portal>
</template>

<script>
export default {
	name: "modal",
	props: {
		show: {
			type: Boolean,
			default: false,
			required: true,
		},
		size: String,
		positionCloseX: {
			type: String,
			required: false,
			default: "", // add i.e 'center' as a class
		},
		target: {
			type: String,
			default: "modal",
			required: false,
		},
		showCloseButton: {
			type: Boolean,
			default: true,
			required: false,
		},
		disableOutSideClick: {
			type: Boolean,
			default: false,
			required: false,
		},
		className: {
			type: String,
			default: "",
			required: false,
		},
	},
	mounted() {
		let vm = this;
		document.addEventListener("keydown", (e) => {
			if (vm.show && e.keyCode == 27) {
				vm.close();
			}
		});
	},
	methods: {
		close() {
			let vm = this;
			vm.$emit("close");
		},
	},
};
</script>

<style lang="scss" scoped>
.modal {
	text-align: left;
	position: relative;
	font-size: var(--font-medium);
	z-index: 999999999999;
	&__x {
		position: absolute;
		color: var(--light-dark-blue);
		left: initial;
		top: 3px;
		right: 3px;
		width: 40px;
		height: 40px;
		line-height: 31px;
		font-size: 35px;
		padding-bottom: 5px;
		// font-weight: var(--font-weight-bold);
		border: none;
		cursor: pointer;
		background: none;
		z-index: 999999999999;
		//POSITION X CENTER
		&.center {
			left: 50%;
			transform: translate(-50%, 0%);
		}
	}
	&__mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		transition: opacity 0.3s ease;
		max-width: var(--app-width);
		margin: 0 auto;
		cursor: pointer;
	}
	&__container {
		position: absolute;
		top: 50%;
		left: 50%;
		width: auto;
		background-color: var(--white);
		transition: all 0.3s ease;
		transform: translate(-50%, -50%);
		color: var(--light-black);
		margin-top: 0 !important;
		letter-spacing: 0.15px;
		background: var(--white);
		box-shadow: 0px 5px 7px rgba(0, 0, 0, 0.1);
		border-radius: 3px;
		padding: 20px;
		cursor: auto;
		padding-top: 50px;
		&.small {
			width: 25vw;
		}
		&.large {
			width: 41.66666667vw;
		}
		&.max {
			width: 80%;
		}
		&.auto {
			width: auto;
			@media (min-width: 1023px) {
				min-width: 25vw;
			}
		}
	}
}
</style>
